import { labels } from "../localization/labels";
import LocalizationUtil from "../localization/LocalizationUtil";
import { httpHeaders } from "../services/httpHeaders";
import PartySession from "../session/PartySession";

const keycloakEvents = {
  READY: "onReady",
  SUCCESSFULLY_AUTHENTICATED: "onAuthSuccess",
  UNSUCCESSFULLY_AUTHENTICATED: "onAuthError",
  SUCCESSFULLY_REFRESHED: "onAuthRefreshSuccess",
  UNSUCCESSFULLY_REFRESHED: "onAuthRefreshError",
  LOGOUT: "onAuthLogout",
  TOKEN_EXPIRED: "onTokenExpired"
};

const keycloakConstants = {
  loginNeededEvents: [
    keycloakEvents.LOGOUT,
    keycloakEvents.UNSUCCESSFULLY_REFRESHED
  ],
  userSaveNeededEvents: [
    keycloakEvents.SUCCESSFULLY_AUTHENTICATED,
    keycloakEvents.SUCCESSFULLY_REFRESHED
  ],
  userDeleteNeededEvents: [
    keycloakEvents.LOGOUT,
    keycloakEvents.UNSUCCESSFULLY_AUTHENTICATED,
    keycloakEvents.UNSUCCESSFULLY_REFRESHED,
    keycloakEvents.TOKEN_EXPIRED
  ],
  tokenRefreshDeadline: 30,
  checkStatusWithEveryRequest: false //unnecessary for now, too much traffic will be generated
};

export const keycloakHeaders = keycloak => ({
  [httpHeaders.AUTHORIZATION]: keycloak?.token
    ? `Bearer ${keycloak.token}`
    : null
});

export const getUser = (keycloak, onLoad) =>
  keycloak.loadUserProfile().then(onLoad);

export const saveUserData = (userData, keycloak) => {
  PartySession.setParty(userData);

  keycloak
    .loadUserProfile()
    .success(userProfile => saveLanguage(userProfile?.attributes?.locale?.[0]));
};

export const isUserSaved = () => PartySession.isPartyLoggedIn();

const saveLanguage = language => {
  if (
    !PartySession.languageExists() ||
    PartySession.getLanguage() !== language
  ) {
    PartySession.setLanguage(language);

    if (!LocalizationUtil.isLocalized(labels)) {
      window.location.reload();
    }
  }
};

export const deleteUserData = () => {
  PartySession.deleteParty();
  deleteLanguage();
};

const deleteLanguage = () => {
  // do nothing for now
  // if (UserSession.languageExists()) {
  //   UserSession.deleteLanguage();
  // }
};

export const onKeycloakEvent = keycloak => event => {
  if (keycloakConstants.userSaveNeededEvents.includes(event)) {
    //do nothing for now
  }

  if (keycloakConstants.userDeleteNeededEvents.includes(event)) {
    deleteUserData();
  }

  if (keycloakConstants.loginNeededEvents.includes(event)) {
    keycloak.login();
  }
};

export const requestLoginIfNeeded = keycloak => {
  keycloak.onReady = function () {
    if (!sessionAuthenticated(keycloak)) {
      deleteUserData();
      keycloak.login();
    }
  };
};

export const sessionAuthenticated = keycloak =>
  keycloak?.authenticated === true;

export const checkSessionStatus = (keycloak, onError = _ => keycloak.login()) =>
  keycloak.loadUserProfile().catch(onError);

export const loginBeforeAction = (keycloak, action) => {
  let shouldLogin = !sessionAuthenticated(keycloak);

  const performLogin = _ => keycloak.login();

  if (!shouldLogin) {
    try {
      if (!keycloak.isTokenExpired()) {
        if (keycloakConstants.checkStatusWithEveryRequest) {
          checkSessionStatus(keycloak);
        }

        //refresh the token if it will expire in next [x] seconds
        keycloak
          .updateToken(keycloakConstants.tokenRefreshDeadline)
          .catch(performLogin);

        return action();
      } else {
        shouldLogin = true;
      }
    } catch (err) {
      shouldLogin = true;
    }
  }

  if (shouldLogin) {
    performLogin();
  }
};
